import {
    LISTAR_CATTIPOESPACIOS,
} from '../../types'


export default (state, action) => {
    switch (action.type){
        case LISTAR_CATTIPOESPACIOS:
            return{
                ...state, 
                tipoEspacios: action.payload
            }
        default:
            return state
    }
        
}